/**
 * Deploy-time brand/nav surface for platform UI.
 * Communio is the parent shell; Paydirt is a vertical child (paydirtConfig) activated only
 * when not a Communio tour/product/ops build — never the default for platform hosts.
 */
import { paydirtConfig, absoluteSiteUrl as paydirtAbsoluteSiteUrl } from './paydirt';

/** Communio Social shell (tenant product, marketing tour, or ops) — never paydirt vertical brand. */
export function isCommunioShellBuild(): boolean {
  return (
    process.env.NEXT_PUBLIC_TOUR_BUILD === 'true' ||
    process.env.NEXT_PUBLIC_COMMUNIO_PRODUCT === 'true' ||
    process.env.NEXT_PUBLIC_COMMUNIO_OPS === 'true'
  );
}

const communioBrand = {
  brandName: process.env.NEXT_PUBLIC_SITE_NAME || 'Communio Social',
  groups: {
    label: 'Groups',
    description: 'Communities for your people — discuss and organize together.',
    path: '/groups/',
  },
  feedback: {
    label: 'Platform feedback',
    description: 'Suggest improvements, report bugs, and vote on what we build next.',
    path: '/feedback/',
  },
  blog: {
    label: 'Blog',
    description: 'Long-form stories and guides from the community.',
    path: '/blog/',
  },
  forum: {
    label: 'Forum',
    description: 'General discussion for your community.',
    path: '/forum/',
    defaultSubSlug: 'general',
  },
  calendar: {
    label: 'Calendar',
    description: 'Community events and important dates.',
    path: '/calendar/',
  },
} as const;

export const brandConfig = isCommunioShellBuild()
  ? communioBrand
  : {
      brandName: paydirtConfig.brandName,
      groups: paydirtConfig.groups,
      feedback: paydirtConfig.feedback,
      blog: paydirtConfig.blog,
      forum: paydirtConfig.forum,
      calendar: paydirtConfig.calendar,
    };

export const absoluteSiteUrl = isCommunioShellBuild()
  ? (path = '/') => {
      const base = (process.env.NEXT_PUBLIC_SITE_URL || 'https://communiosocial.com').replace(/\/$/, '');
      const p = path.startsWith('/') ? path : `/${path}`;
      return `${base}${p}`;
    }
  : paydirtAbsoluteSiteUrl;
